import React, { Component } from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import ManagerLocationPage from "./ManagerLocationPage";
import LegalEntities from "./LegalEntities";
import MRCPage from "./MRCPage";
import CostCenterPage from "./CostCenterPage";
import Modal from "react-modal";
import HeadCountMRC from "./HeadCountMRC";
import HeadCountCostCenter from "./HeadCountCostCenter";
import EndPage from "./EndPage";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mngwwid: "",
      mngName: "",
      manageractualLocation: "",
      locationName: "",
      locationreferenceID: "",
      isManagerLocation: true,
      isLegalEntities: false,
      isPayrollMRC: false,
      leID: "",
      leName: "",
      isPayrollCC: false,
      payrollMRCCode: "",
      payrollMRCName: "",
      sessionID: "",
      payrollCCCode: "",
      payrollCCName: "",
      selectedlevelCC: "",
      selectedlevelHCC: "",
      DecisionmodalOpen: false,
      isEndPage: false,
      isHeadCountMRC: false,
      headCountMRCCode: "",
      headCountMRCName: "",
      isHeadCountCC: false,
      headCountCCName: "",
      headCountCCCode: "",
      outputmsg: "",
      summaryTakenAtStage: "",
      noneOfTheAboveSelected: false,
      stepNumber: 0,
      isLEDataPresent: true,
      regionName: "",
      countryName: "",
      stateName: "",
      /*-- Summary Card Diplay Switch --*/
      isDisplayheader: false,
      isDisplaymngwwid: false,
      isDisplaylocationname: false,
      isDisplaylename: false,
      isDisplaypmrcname: false,
      isDisplaypccname: false,
      isDisplayhmrcname: false,
      isDisplayhccname: false,
      windowheight: 0,
    };
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }
  updateWindowDimensions = () => {
    this.setState({
      windowheight:
        window.innerHeight -
        this.Dimension("headercontent") -
        this.Dimension("footercontent"),
    });
  };
  Dimension = (elmID) => {
    var elmHeight,
      elmMargin,
      elm = document.getElementsByClassName(elmID)[0];
    if (document.all) {
      // IE
      elmHeight = elm.clientHeight;
      elmMargin =
        parseInt(elm.currentStyle.marginTop, 10) +
        parseInt(elm.currentStyle.marginBottom, 10);
    } else {
      // Mozilla
      elmHeight = elm.clientHeight;
      elmMargin =
        parseInt(
          document.defaultView
            .getComputedStyle(elm, "")
            .getPropertyValue("margin-top")
        ) +
        parseInt(
          document.defaultView
            .getComputedStyle(elm, "")
            .getPropertyValue("margin-bottom")
        );
    }
    return elmHeight + elmMargin + 6;
  };
  /*---Suggested Legal Entities when valid Manager's WWID and Location entered by User---*/
  handleUserInput = (
    mngID,
    locationId,
    mngname,
    locationname,
    regionname,
    countryname,
    statename,
    mngactuallocation
  ) => {
    this.setState({
      mngwwid: mngID,
      locationreferenceID: locationId,
      mngName: mngname,
      locationName: locationname,
      regionName: regionname,
      countryName: countryname,
      stateName: statename,
      manageractualLocation: mngactuallocation,
      sessionID: "",
      isManagerLocation: false,
      isLegalEntities: true,
      isDisplayheader: true,
      isDisplaymngwwid: true,
      isDisplaylocationname: true,
      stepNumber: 1,
    });
  };
  /*---Summary/Last Screen display if there is no Legal Entities when valid Manager's WWID and Location entered by User---*/
  noOrganisaion = (sessionid) => {
    this.setState({
      sessionID: sessionid,
      isManagerLocation: false,
      isLegalEntities: false,
      outputmsg: "nodata",
      noneOfTheAboveSelected: false,
      summaryTakenAtStage: "nosuggestion",
      isEndPage: true,
      stepNumber: 2,
    });
  };
  /*---Suggested Payroll MRC when valid Legal Entities entered by User---*/
  handleLEInput = (lecode, lename, sessionid) => {
    if (lecode != "noa") {
      this.setState({
        leID: lecode,
        leName: lename,
        sessionID: sessionid,
        isPayrollMRC: true,
        stepNumber: 1,
        isLegalEntities: false,
        isDisplaylename: true,
        summaryTakenAtStage: "legalEntity",
      });
    } else {
      this.setState({
        sessionID: sessionid,
        isPayrollMRC: false,
        isLegalEntities: false,
        outputmsg: "noa",
        noneOfTheAboveSelected: true,
        summaryTakenAtStage: "legalEntity",
        isEndPage: true,
        stepNumber: 2,
      });
    }
  };
  /*---Back to the user Input Screen when user click on back in Legal Entities Screen--- */
  handleLEBack = () => {
    this.setState({
      isLegalEntities: false,
      isManagerLocation: true,
      isDisplaymngwwid: false,
      isDisplayheader: false,
      isDisplaylocationname: false,
      stepNumber: 0,
    });
  };
  /*---Suggested Payroll CostCenter when valid payroll MRC entered by User---*/
  handlePayrollMRCInput = (mrccode, mrcname, sessionid) => {
    if (mrccode != "noa") {
      this.setState({
        payrollMRCCode: mrccode,
        payrollMRCName: mrcname,
        sessionID: sessionid,
        isPayrollMRC: false,
        isPayrollCC: true,
        isDisplaypmrcname: true,
        summaryTakenAtStage: "payrollMRC",
        stepNumber: 1,
      });
    } else {
      this.setState({
        payrollMRCCode: "",
        payrollMRCName: "",
        sessionID: sessionid,
        isPayrollMRC: false,
        isPayrollCC: false,
        isEndPage: true,
        outputmsg: "noa",
        noneOfTheAboveSelected: true,
        summaryTakenAtStage: "payrollMRC",
        stepNumber: 2,
      });
    }
  };
  /*---Back to the Legal Entities Screen when user click on back in Payroll MRC Screen--- */
  handlePayrollMRCBack = (sessionid) => {
    this.setState({
      sessionID: sessionid,
      isDisplaylename: false,
      isLegalEntities: true,
      stepNumber: 1,
    });
  };
  /*---Decision Modal Popup open with yes/no when valid payroll Costcenter entered by User---*/
  handlePayrollCCInput = (payrollCCcode, payrollName, levelselected) => {
    if (payrollCCcode != "noa") {
      this.setState({
        payrollCCCode: payrollCCcode,
        payrollCCName: payrollName,
        selectedlevelCC: levelselected,
        DecisionmodalOpen: true,
        isDisplaypccname: true,
        summaryTakenAtStage: "payrollCostCenter",
      });
    } else {
      this.setState({
        payrollCCCode: "",
        payrollCCName: "",
        isPayrollCC: false,
        isEndPage: true,
        outputmsg: "noa",
        noneOfTheAboveSelected: true,
        summaryTakenAtStage: "payrollCostCenter",
        stepNumber: 2,
      });
    }
  };
  /*---Back to the payroll MRC Screen when user click on back in Payroll Costcenter Screen--- */
  handlePayrollCCBack = () => {
    this.setState({
      isDisplaypmrcname: false,
      isPayrollMRC: true,
      stepNumber: 1,
    });
  };
  /*---Summary/Last Screen comes when no clicked by user in modal pop-up---*/
  noDecisionCard = () => {
    this.setState({
      DecisionmodalOpen: false,
      isPayrollCC: false,
      isEndPage: true,
      isDisplayhmrcname: false,
      isDisplayhccname: false,
      outputmsg: "success",
      noneOfTheAboveSelected: false,
      summaryTakenAtStage: "payrollCostCenter",
      stepNumber: 2,
    });
  };
  /*---Suggested HeadCount MRC when yes clicked by user in modal pop-up---*/
  yesDecisionCard = () => {
    this.setState({
      DecisionmodalOpen: false,
      isPayrollCC: false,
      isEndPage: false,
      isHeadCountMRC: true,
      stepNumber: 1,
    });
  };
  /*---Back to the payroll Costcenter Screen when user click on back in HeadCount MRC Screen--- */
  handleHeadCountMRCBack = () => {
    this.setState({
      isDisplaypccname: false,
      isPayrollCC: true,
      stepNumber: 1,
    });
  };
  /*---Suggested HeadCount CostCenter when valid Headcount MRC entered by User---*/
  handleHeadCountMRCInput = (mrccode, mrcname) => {
    if (mrccode != "noa") {
      this.setState({
        headCountMRCCode: mrccode,
        headCountMRCName: mrcname,
        isHeadCountMRC: false,
        isHeadCountCC: true,
        isDisplayhmrcname: true,
        summaryTakenAtStage: "headcountMRC",
        stepNumber: 1,
      });
    } else {
      this.setState({
        headCountMRCCode: "",
        headCountMRCName: "",
        isHeadCountMRC: false,
        isEndPage: true,
        outputmsg: "noa",
        noneOfTheAboveSelected: true,
        summaryTakenAtStage: "headcountMRC",
        stepNumber: 2,
      });
    }
  };
  /*---Back to the HeadCount MRC Screen when user click on back in HeadCount Costcenter Screen--- */
  handleHeadCountCCBack = () => {
    this.setState({
      isDisplayhmrcname: false,
      isHeadCountMRC: true,
      stepNumber: 1,
    });
  };
  /*---Summary/Last Screen comes when valid Headcount Costcenter entered by User---*/
  handleHeadCountCCInput = (hcccode, hccname, levelselectedhcc) => {
    if (hcccode != "noa") {
      this.setState({
        headCountCCCode: hcccode,
        headCountCCName: hccname,
        selectedlevelHCC: levelselectedhcc,
        isHeadCountCC: false,
        isEndPage: true,
        isDisplayhccname: true,
        outputmsg: "success",
        noneOfTheAboveSelected: false,
        summaryTakenAtStage: "headcountCostCenter",
        stepNumber: 2,
      });
    } else {
      this.setState({
        headCountCCCode: "",
        headCountCCName: "",
        isHeadCountCC: false,
        isEndPage: true,
        outputmsg: "noa",
        noneOfTheAboveSelected: true,
        summaryTakenAtStage: "headcountCostCenter",
        stepNumber: 2,
      });
    }
  };
  /*--- when user click on back in Summary/Last Screen it will Back to the Particular Screen where user clicked None of the above---*/
  handleEndPageBack = () => {
    if (this.state.summaryTakenAtStage == "legalEntity") {
      if (this.state.outputmsg == "noa") {
        this.setState({
          leID: "noa",
          leName: "noa",
        });
      }
      this.setState({
        isEndPage: false,
        isLegalEntities: true,
        stepNumber: 1,
      });
    } else if (this.state.summaryTakenAtStage == "payrollMRC") {
      if (this.state.outputmsg == "noa") {
        this.setState({
          payrollMRCCode: "noa",
          payrollMRCName: "noa",
        });
      }
      this.setState({
        isEndPage: false,
        isPayrollMRC: true,
        stepNumber: 1,
      });
    } else if (this.state.summaryTakenAtStage == "payrollCostCenter") {
      if (this.state.outputmsg == "noa") {
        this.setState({
          payrollCCCode: "noa",
          payrollCCName: "noa",
        });
      }
      this.setState({
        isEndPage: false,
        isPayrollCC: true,
        isDisplaypccname: false,
        stepNumber: 1,
      });
    } else if (this.state.summaryTakenAtStage == "headcountMRC") {
      if (this.state.outputmsg == "noa") {
        this.setState({
          headCountMRCCode: "noa",
          headCountMRCName: "noa",
        });
      }
      this.setState({
        isEndPage: false,
        isHeadCountMRC: true,
        stepNumber: 1,
      });
    } else if (this.state.summaryTakenAtStage == "headcountCostCenter") {
      if (this.state.outputmsg == "noa") {
        this.setState({
          headCountCCCode: "noa",
          headCountCCName: "noa",
        });
      }
      this.setState({
        isEndPage: false,
        isHeadCountCC: true,
        isDisplayhccname: false,
        stepNumber: 1,
      });
    } else if (this.state.summaryTakenAtStage == "nosuggestion") {
      this.setState({
        isLegalEntities: false,
        isManagerLocation: true,
        isDisplaymngwwid: false,
        isDisplayheader: false,
        isDisplaylocationname: false,
        stepNumber: 0,
      });
    }
  };
  /*---Navigate To user Input Screen when user clicked on startover in Summary/Last Screen---*/
  handleEndPageNext = () => {
    this.setState({
      stepNumber: 0,
    });
    window.location.reload(false);
  };

  render() {
    // console.log({ state: this.state });
    const steps = ["Manager & Location", "Organization Codes", "Done"];
    return (
      <div className="contentbody">
        <div
          className="some-page-wrapper"
          style={{ minHeight: +this.state.windowheight }}
        >
          <div className="headerrow">
            <div className="headercolumn mainheadcolumn">
              <div className="last-column">
                <div className="headerrow">
                  <div className="headercolumn">
                    <div className="last-column">
                      <Stepper
                        activeStep={this.state.stepNumber}
                        alternativeLabel
                      >
                        {steps.map((label) => (
                          <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                          </Step>
                        ))}
                      </Stepper>
                    </div>
                  </div>
                </div>
                <div className="headerrow">
                  <div className="headercolumn">
                    <div className="last-column">
                      {this.state.isManagerLocation === true ? (
                        <ManagerLocationPage
                          onclickManagerLocationNext={this.handleUserInput}
                          mngwwid={this.state.mngwwid}
                          locationId={this.state.locationreferenceID}
                          mngName={this.state.mngName}
                          regionname={this.state.regionName}
                          countryname={this.state.countryName}
                          statename={this.state.stateName}
                          manageractualLocation={
                            this.state.manageractualLocation
                          }
                        />
                      ) : this.state.isLegalEntities === true ? (
                        <LegalEntities
                          mngwwid={this.state.mngwwid}
                          locationreferenceID={this.state.locationreferenceID}
                          sessionID={this.state.sessionID}
                          onclickLENext={this.handleLEInput}
                          onclickLEBack={this.handleLEBack}
                          lecode={this.state.leID}
                          leName={this.state.leName}
                          isLePresent={this.noOrganisaion}
                        />
                      ) : this.state.isPayrollMRC === true ? (
                        <MRCPage
                          mngwwid={this.state.mngwwid}
                          locationreferenceID={this.state.locationreferenceID}
                          lecode={this.state.leID}
                          mrcName={this.state.payrollMRCName}
                          mrccode={this.state.payrollMRCCode}
                          sessionID={this.state.sessionID}
                          onclickPayrollMRCNext={this.handlePayrollMRCInput}
                          onclickpayrollMRCBack={this.handlePayrollMRCBack}
                        />
                      ) : this.state.isPayrollCC === true ? (
                        <CostCenterPage
                          mngwwid={this.state.mngwwid}
                          locationreferenceID={this.state.locationreferenceID}
                          lecode={this.state.leID}
                          mrccode={this.state.payrollMRCCode}
                          sessionID={this.state.sessionID}
                          payrollCCCode={this.state.payrollCCCode}
                          payrollCCName={this.state.payrollCCName}
                          selectedlevelCC={this.state.selectedlevelCC}
                          onclickPayrollCCNext={this.handlePayrollCCInput}
                          onclickpayrollCCBack={this.handlePayrollCCBack}
                        />
                      ) : this.state.isEndPage === true ? (
                        <EndPage
                          outputmsg={this.state.outputmsg}
                          sessionID={this.state.sessionID}
                          mngName={this.state.mngName}
                          mngwwid={this.state.mngwwid}
                          locationreferenceID={this.state.locationreferenceID}
                          managerlocation={this.state.locationName}
                          lecode={this.state.leID}
                          leName={this.state.leName}
                          payrollmrccode={this.state.payrollMRCCode}
                          payrollMRCName={this.state.payrollMRCName}
                          payrollCCCode={this.state.payrollCCCode}
                          payrollCCName={this.state.payrollCCName}
                          headCountMRCCode={this.state.headCountMRCCode}
                          headCountMRCName={this.state.headCountMRCName}
                          headcountCCcode={this.state.headCountCCCode}
                          headCountCCName={this.state.headCountCCName}
                          summaryTakenAtStage={this.state.summaryTakenAtStage}
                          noneOfTheAboveSelected={
                            this.state.noneOfTheAboveSelected
                          }
                          onclickEndPageBack={this.handleEndPageBack}
                          onclickEndPageNext={this.handleEndPageNext}
                        />
                      ) : this.state.isHeadCountMRC === true ? (
                        <HeadCountMRC
                          mngwwid={this.state.mngwwid}
                          locationreferenceID={this.state.locationreferenceID}
                          lecode={this.state.leID}
                          sessionID={this.state.sessionID}
                          headCountMRCCode={this.state.headCountMRCCode}
                          headCountMRCName={this.state.headCountMRCName}
                          onclickHeadCountMRCNext={this.handleHeadCountMRCInput}
                          onclickHeadCountMRCBack={this.handleHeadCountMRCBack}
                        />
                      ) : this.state.isHeadCountCC === true ? (
                        <HeadCountCostCenter
                          mngwwid={this.state.mngwwid}
                          locationreferenceID={this.state.locationreferenceID}
                          lecode={this.state.leID}
                          headCountMRCCode={this.state.headCountMRCCode}
                          sessionID={this.state.sessionID}
                          headcountCCcode={this.state.headCountCCCode}
                          headCountCCName={this.state.headCountCCName}
                          selectedlevelHCC={this.state.selectedlevelHCC}
                          onclickheadCountCCNext={this.handleHeadCountCCInput}
                          onclickHeadCountCCBack={this.handleHeadCountCCBack}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="headercolumn summaryheadercolumn">
              <div className="last-column">
                <div className="headerrow">
                  <div className="headercolumn">
                    <div className="last-column">
                      <h4
                        className={
                          this.state.isDisplayheader === true
                            ? "summaryheadtext"
                            : "disableheader"
                        }
                      >
                        Your Selected values:
                      </h4>
                    </div>
                  </div>
                </div>
                {this.state.isDisplaymngwwid === true ? (
                  <div className="headerrow">
                    <div className="headercolumn">
                      <div className="last-column">
                        <h4 className="summaryheader">Hiring Manager</h4>
                        <p className="summarytext">
                          {this.state.mngwwid} - {this.state.mngName}
                        </p>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {this.state.isDisplaylocationname === true ? (
                  <div className="headerrow">
                    <div className="headercolumn">
                      <div className="last-column">
                        <h4 className="summaryheader">Requistion Location</h4>
                        <p className="summarytext">{this.state.locationName}</p>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {this.state.isDisplaylename === true ? (
                  <div className="headerrow">
                    <div className="headercolumn">
                      <div className="last-column">
                        <h4 className="summaryheader">Legal Entity</h4>
                        <p className="summarytext">
                          {this.state.leID} - {this.state.leName}
                        </p>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {this.state.isDisplaypmrcname === true ? (
                  <div className="headerrow">
                    <div className="headercolumn">
                      <div className="last-column">
                        <h4 className="summaryheader">Payroll MRC</h4>
                        <p className="summarytext">
                          {this.state.payrollMRCCode} -{" "}
                          {this.state.payrollMRCName}
                        </p>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {this.state.isDisplaypccname === true ? (
                  <div className="headerrow">
                    <div className="headercolumn">
                      <div className="last-column">
                        <h4 className="summaryheader">Payroll Cost Center</h4>
                        <p className="summarytext">
                          {this.state.payrollCCCode} -{" "}
                          {this.state.payrollCCName}
                        </p>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {this.state.isDisplayhmrcname === true ? (
                  <div className="headerrow">
                    <div className="headercolumn">
                      <div className="last-column">
                        <h4 className="summaryheader">Headcount MRC</h4>
                        <p className="summarytext">
                          {this.state.headCountMRCCode} -{" "}
                          {this.state.headCountMRCName}
                        </p>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {this.state.isDisplayhccname === true ? (
                  <div className="headerrow">
                    <div className="headercolumn">
                      <div className="last-column">
                        <h4 className="summaryheader">Headcount Cost Center</h4>
                        <p className="summarytext">
                          {this.state.headCountCCCode} -{" "}
                          {this.state.headCountCCName}
                        </p>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.DecisionmodalOpen} className="Modal">
          <div className="outer">
            <div className="middle">
              <div className="middleheadermodal">
                <h1 className="header-margin-class"></h1>
                <p className="para-margin-class ">
                  Will the costs for this Position need to be accounted for in a
                  organization different from the Position’s location(i.e. cross
                  charged between Consumer US and Corporate US?)
                </p>
              </div>
              <div className="decisioncard">
                <input
                  type="submit"
                  value="No"
                  className="btnno"
                  onClick={this.noDecisionCard}
                />
                <input
                  type="submit"
                  value="Yes"
                  className="btnyes"
                  onClick={this.yesDecisionCard}
                />
                <div>
                  <button className="primaryBtn continueBtn respobtn self"></button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
export default HomePage;
